import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const PRODUCT_CATEGORY_SCHEMA = order.orderService.versions.v1.schemas.PRODUCT_CATEGORY_SCHEMA;
export type PRODUCT_CATEGORY = z.infer<typeof PRODUCT_CATEGORY_SCHEMA>;

export const PRODUCT_CATEGORIES = {
    MATERIAL: PRODUCT_CATEGORY_SCHEMA.enum.MATERIAL,
    TRANSPORT: PRODUCT_CATEGORY_SCHEMA.enum.TRANSPORT,
    MATERIAL_SERVICE: PRODUCT_CATEGORY_SCHEMA.enum.MATERIAL_SERVICE,
    TRANSPORT_SERVICE: PRODUCT_CATEGORY_SCHEMA.enum.TRANSPORT_SERVICE,
} as const;
